import React from "react";
import {
  List,
  Datagrid,
  TextField,
  DateField,
  EditButton,
  RefreshButton,
  Filter,
  TextInput,
  WithPermission,
  CreateButton
} from "admin-on-rest";
import { CardActions } from "material-ui/Card";

import IconTitle from "../components/icon_title";
import Pagination from "../components/pagination";

import { ROLE_ADMIN } from "../App";

const CorporateCampaignActions = ({ resource, basePath, refresh }) => (
  <CardActions
    style={styles.cardActionStyleSmall}
    className="corporate_campaign-actions"
  >
    <WithPermission value={ROLE_ADMIN}>
      <CreateButton basePath={basePath} />
    </WithPermission>
    <RefreshButton basePath={basePath} refresh={refresh} />
  </CardActions>
);
const CorporateCampaignFilter = ({ ...props }) => (
  <Filter {...props}>
    <TextInput
      label="resources.orders.actions.search"
      source="search"
      alwaysOn
    />
  </Filter>
);

export const CorporateCampaignList = props => (
  <List
    {...props}
    actions={<CorporateCampaignActions />}
    filters={<CorporateCampaignFilter />}
    title={
      <IconTitle
        icon="categories"
        title={"resources.corporate_campaign.title"}
      />
    }
    pagination={<Pagination />}
  >
    {permissions => (
      <Datagrid bodyOptions={{ showRowHover: true }}>
        <TextField
          label="resources.corporate_campaign.field.name"
          source="name"
        />
        <DateField
          label="resources.corporate_campaign.field.start_date"
          source="start_date"
        />
        <DateField
          label="resources.corporate_campaign.field.end_date"
          source="end_date"
        />
        {permissions === ROLE_ADMIN && (
          <EditButton label="" style={{ textAlign: "right" }} {...props} />
        )}
      </Datagrid>
    )}
  </List>
);

const styles = {
  cardActionStyleSmall: {
    zIndex: 2,
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end"
  }
};



// WEBPACK FOOTER //
// ./src/corporate_campaign/CorporateList.js